import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import { Action } from 'redux';
import ProjectComment from 'src/entities/ProjectComment';
import ProjectChildComment from 'src/entities/ProjectChildComment';
import ProjectCommentCardComponent, { ProjectCommentCardComponentProps } from './ProjectCommentCard.component';
import {
  createProjectChildComment,
  CreateProjectChildCommentAction
} from 'src/actions/project/comments/create-child-comment/CreateProjectChildComment.actions';
import * as createProjectChildCommentTypes from 'src/actions/project/comments/create-child-comment/Types';
import {
  getProjectComments,
  GetProjectCommentsAction
} from 'src/actions/project/comments/get/GetProjectComments.actions';
import { openModal, OpenModal } from 'src/actions/modal';
import CommentSuccessComponent from 'src/modules/project/partials/comments/CommentSuccess.component';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';

interface DispatchProps {
  createProjectChildComment: (projectChildComment: ProjectChildComment) => Promise<CreateProjectChildCommentAction>;
  getProjectComments: (projectId: number) => Promise<GetProjectCommentsAction>;
  openModal: (component: JSX.Element, className: string) => void;
}

interface Props extends DispatchProps {
  comment: ProjectComment;
  modalRef?: Modal;
}

interface State {
  newComment: ProjectChildComment;
  response: boolean;
}

class ProjectCommentCardContainer extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    this.state = {
      newComment: new ProjectChildComment({
        id: undefined,
        body: '',
        authorId: undefined,
        authorName: undefined,
        parentCommentId: this.props.comment.id!,
        createdAt: undefined,
      }),
      response: false,
    };
  }

  public render(): React.ReactNode {
    return (
      <ProjectCommentCardComponent {...this.getComponentProps()} />
    );
  }

  private showInputComment(respondingTo: string, show: boolean): void {
    this.setState({response: show});
    this.handleChange('<b>' + respondingTo + '</b> <p>&nbsp;</p>');
    if (show) {
      setTimeout(
        () => {
          const element = document.getElementById('input-comment-' + this.props.comment.id);
          if (element) {
            element.scrollIntoView({block: 'center', behavior: 'smooth'});
          }
        },
        0
      );
    }
  }

  private handleChange(value: string): void {
    const newComment = this.state.newComment;
    newComment.body = value;
    this.setState({newComment: newComment});
  }

  private handleSubmit(): void {
    if (this.state.newComment) {
      this.props.createProjectChildComment(this.state.newComment).then((response: Action) => {
        if (response.type === createProjectChildCommentTypes.CREATE_PROJECT_CHILD_COMMENT_SUCCESS) {
          this.props.openModal(
            <CommentSuccessComponent
              modalRef={this.props.modalRef}
            />,
            'large'
          );
          this.setState({response: false});
          this.props.getProjectComments(this.props.comment.projectId);
          this.handleChange('');
        }
      });
    }
  }

  private getComponentProps(): ProjectCommentCardComponentProps {
    return {
      comment: this.props.comment,
      newComment: this.state.newComment.body,
      response: this.state.response,
      showInputComment: (respondingTo: string, show: boolean) => this.showInputComment(respondingTo, show),
      handleChange: (value: string) => this.handleChange(value),
      handleSubmit: () => this.handleSubmit(),
    };
  }

}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  createProjectChildComment: (projectChildComment: ProjectChildComment): Promise<CreateProjectChildCommentAction> => (
    dispatch(createProjectChildComment(projectChildComment))
  ),
  getProjectComments: (projectId: number): Promise<GetProjectCommentsAction> => (
    dispatch(getProjectComments(projectId))
  ),
  openModal: (component: JSX.Element, className: string): OpenModal => (
    dispatch(openModal(component, className))
  )
});

export default connect(null, mapDispatchToProps)(ProjectCommentCardContainer);


// WEBPACK FOOTER //
// ./src/modules/project/partials/comments/ProjectCommentCard.container.tsx